export default __webpack_public_path__ + "static/media/0xb77e62709e39ad1cbeebe77cf493745aec0f453a.e31e064c.webp";